import { useLocation, useNavigate } from "react-router-dom";
import { Star } from "@phosphor-icons/react";
import { FLAT_ROUTES } from "./Sidebar";
import { useAuth } from "@/context/AuthContext";
import { canAccessRoute } from "@/lib/permissions";

/** Accesos directos del usuario (máx. 3) en la barra negra superior. */
export default function FavoritosBar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const favs = (user?.favoritos || []).filter((p) => FLAT_ROUTES[p] && canAccessRoute(user, p));
  if (!user) return null;

  return (
    <div className="flex items-center gap-1 shrink-0" data-testid="favoritos-bar">
      {favs.length === 0 ? (
        <span className="hidden lg:flex items-center gap-1 text-[10px] text-neutral-500 font-mono uppercase tracking-wider px-1" data-testid="favoritos-empty">
          <Star size={11} /> Fijá hasta 3 pantallas con la estrella del menú
        </span>
      ) : favs.map((path) => {
        const { label, icon: Icon } = FLAT_ROUTES[path];
        const active = location.pathname === path;
        return (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            title={label}
            data-testid={`favorito-${path.replace(/\//g, "-")}`}
            className={`flex items-center gap-1.5 h-7 px-2.5 rounded-md text-[12px] font-medium transition-colors ${
              active ? "bg-[#A02836] text-white" : "text-neutral-200 hover:bg-white/10 hover:text-white"
            }`}
          >
            {Icon && <Icon size={14} weight={active ? "fill" : "regular"} />}
            <span className="hidden md:inline truncate max-w-[160px]">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
